import React from "react";
import "./style.scss";

const Footer = ({ theme, bgColor, textColor }) => {
  return (
    <div
      className="footer-section"
      style={{ backgroundColor: bgColor || "white" }}
    >
      <div className="footer-container">
        <div className="bootom-footer">
          <div className="details" style={{ color: textColor || "black" }}>
            {new Date().getFullYear()} ©
            {window.env.COPYRIGHT || (
              <>
                <span
                  style={{ color: textColor || theme.ThemeColor.item.Text }}
                >
                  <b>SPlus All Rights Reserved </b>
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
